export const AlertApproved = ({ color = '#363BC4', size = 11 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={(size * 12) / 11}
    fill="none"
    viewBox="0 0 11 12"
  >
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M9.47 6.316V3.43c0-.85 0-1.276-.173-1.6a1.56 1.56 0 0 0-.694-.664C8.263 1 7.82 1 6.93 1H3.541c-.89 0-1.334 0-1.674.166a1.56 1.56 0 0 0-.694.663C1 2.154 1 2.58 1 3.43v5.265c0 .85 0 1.276.173 1.6.152.287.395.519.694.665.34.165.785.165 1.674.165h1.694m1.06-5.569H3.117m1.058 2.025H3.118m4.235-4.05H3.118m3.44 6.075 1.06 1.013L10 8.34"
    />
  </svg>
);
